export default {"src":"/_next/static/media/help.b5664fb1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};